import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { Nav, Image, Button, Accordion, Navbar } from '@themesberg/react-bootstrap';

import { Routess } from "../Routes/routes";
import { useHasPermission } from "../helpers/useApi";
import { sidebarMenu } from "../Routes/SidebarMenu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from "../store/AuthContext";
import { useIsMobile } from "../helpers/useIsMobile";

const Sidebar = () => {
  const { isSidebarCollapsed, setIsSidebarCollapsed } = useAuth();
  const isMobile = useIsMobile(); // detects <768px
  const effectiveCollapsed = isSidebarCollapsed;
  const location = useLocation();
  const hasPermission = useHasPermission();

  useEffect(() => {
    if (isMobile) {
      setIsSidebarCollapsed(true); // collapse
    }
  }, [location.pathname, isMobile, setIsSidebarCollapsed]);

  const filteredMenu = useMemo(() => {
    return sidebarMenu.filter(item => !item.permission || hasPermission(item.permission));
  }, [hasPermission]);

  const CollapsableNavItem = ({ eventKey, title, icon, children }) => {
    const [activeKey, setActiveKey] = useState(localStorage.getItem("activeMenu") || "");
    useEffect(() => {
      if (location.pathname.includes(eventKey)) {
        setActiveKey(eventKey);
        localStorage.setItem("activeMenu", eventKey);
      }
    }, [location.pathname, eventKey]);
  
    const handleToggle = () => {
      const newActiveKey = activeKey === eventKey ? "" : eventKey;
      setActiveKey(newActiveKey);
  
      if (newActiveKey) {
        localStorage.setItem("activeMenu", newActiveKey);
      } else {
        localStorage.removeItem("activeMenu"); // Remove from localStorage if collapsed
      }
    };
  
    return (
      <Accordion as={Nav.Item} activeKey={activeKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} onClick={handleToggle}>
            <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /></span>
            <span className="sidebar-text">{title}</span>
          </Accordion.Button>
          <Accordion.Body>
            <Nav className="flex-column">{children}</Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };
  

  return (
    <>
      <CSSTransition timeout={300} classNames="sidebar-transition">
        <div style={{zIndex:150, }} className={`sidebar d-md-block bg-primary text-white ${effectiveCollapsed ? "collapsed" : "expanded"}`}>
          <div className="sidebar-inner">
            <Nav className="flex-column pt-3 pt-md-0">
            <Navbar.Brand className="text-center" as={Link} to={Routess.DashboardOverview.path}>
              <div className="d-flex align-items-end">
                <Image src="tlogo.png" className="navbar-brand-light" style={{height:100, width:100}} />
                {/* <h6 style={{fontSize:12}}>CRM</h6> */}
              </div>
            </Navbar.Brand>
              {filteredMenu.map(item => (
                item.children ? (
                  <CollapsableNavItem key={item.title} eventKey={item.eventKey} title={item.title} icon={item.icon}>
                    {item.children.filter(child => !child.permission || hasPermission(child.permission)).map(child => (
                      <Nav.Item key={child.title}>
                        <Nav.Link className="ms-4" as={Link} to={child.link}>{child.title}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </CollapsableNavItem>
                ) : (
                  <Nav.Item key={item.title}>
                    <Nav.Link as={Link} to={item.link}>
                      <FontAwesomeIcon icon={item.icon} className="sidebar-icon" style={{width:30}} />
                      {item.title}
                    </Nav.Link>
                  </Nav.Item>
                )
              ))}
              <div className="my-4"></div>
            </Nav>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default Sidebar;
